module.exports = "/assets/logo_sg_dimension-e11eeb849800782c9a8c508d74795875.png";